import { computed, Injectable, signal } from '@angular/core';
import { Offer } from '../../offers/models/offers.model';

export type SlideOutType = 'hsl';
export type SlideOutPlacement = '_HERO' | '_SECONDARY' | '_CAROUSEL';

interface SlideOutState {
  type: SlideOutType;
  offer: Offer;
  placement: SlideOutPlacement;
}

@Injectable({
  providedIn: 'root',
})
export class SlideOutService {
  private readonly _activeSlideOut = signal<SlideOutState | null>(null);

  readonly activeOffer = computed(() => this._activeSlideOut()?.offer ?? null);
  readonly activePlacement = computed(() => this._activeSlideOut()?.placement ?? '_HERO');

  readonly isHslSlideOutOpen = computed(() => this._activeSlideOut()?.type === 'hsl');

  open(type: SlideOutType, offer: Offer, placement: SlideOutPlacement = '_HERO') {
    this._activeSlideOut.set({ type, offer, placement });
  }

  close() {
    this._activeSlideOut.set(null);
  }
}
